import { createContext } from 'react';
import { InterimsTimelineEntry } from 'common/components/SessionHistory/services/SessionHistoryApi';
import { Interims, Interim } from 'common/components/SessionHistory/utils/interims';
import { ValuesType } from 'utility-types';

type InterimsTimelineContextProps = {
  interimsTimeline: InterimsTimelineEntry[];
  fetchingInterims: boolean;

  selectedInterimId: string;
  selectedInterim: ValuesType<Interims> | null;
  startInterim: Interim | null;
  startInterimMarked: boolean;
  markedInterimStart: Date | null;
  markedInterimStop: Date | null;

  selectInterimById: (interimId: string) => void;
  selectStartInterim: () => void;
  markSelectedInterimAsDefault: () => void;
  unselectInterim: () => void;

  sessionStart: Date;
  sessionEnd: Date;
};

export const InterimsTimelineContext = createContext<InterimsTimelineContextProps>(
  {} as InterimsTimelineContextProps,
);
